<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { User } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserForm from '@/components/users/UserForm.vue';
    import { RoleOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import ToggleActivationUser from './ToggleActivationUser.vue';
    import QueryKey from '@/enums/QueryKey';

    const { t } = useI18n();

    const props = defineProps<{
        user: User;
    }>();

    const form = useForm({
        name: props.user.name,
        email: props.user.email,
        phone: props.user.phone,
        role_ids: props.user.roles.map((role) => ({
            id: role.id,
            name: role.name,
            company_id: role.pivot.company_id,
        })),
        company_ids: props.user.companies.map((company) => company.id.toString()),
        contact_persons: props.user.contact_person_companies.map((company) =>
            company.id.toString(),
        ),
        language: props.user.language,
    });
</script>

<template>
    <DialogForm
        :key="user.id"
        type="update"
        :form="form"
        :route="route('v2.users.update', user.id)"
        :query-key="[QueryKey.USERS]"
        title="users.edit_txt"
        modal-size="sm:max-w-xl"
        :success-message-translated="t('users.update.success', { username: form.name })"
        :transform="
            (data) => ({
                ...data,
                role_ids: data.role_ids.map((role: RoleOption) => `${role.company_id}_${role.id}`),
            })
        "
    >
        <UserForm :form="form" />

        <template #footerActions>
            <ToggleActivationUser :user="user" />
        </template>
    </DialogForm>
</template>
